"use strict";
var appn;
(function (appn) {
    var sideFilterAndContent;
    (function (sideFilterAndContent) {
        class InitArgs {
            constructor() {
                this.optionalContentToTheRight = false;
                this.showButtonText = appn.emptyString;
                this.showButtonIcon = appn.emptyString;
            }
        }
        let _initArgs;
        function init(args) {
            _initArgs = args;
            addEvents();
            if (appn.localStorage.getItem('sidefilter-toggle-collapsed')) {
                hideSideFilter();
                return;
            }
            $('body').removeClass('sideFilter-hidden').addClass('sideFilter-shown');
        }
        sideFilterAndContent.init = init;
        function appendShowButton(hostElementSelector, classes) {
            if (!hostElementSelector)
                return;
            hostElementSelector.append(getShowBtn(classes));
            init(_initArgs);
        }
        sideFilterAndContent.appendShowButton = appendShowButton;
        function prependShowButton(hostElementSelector, classes) {
            if (!hostElementSelector)
                return;
            hostElementSelector.prepend(getShowBtn(classes));
            init(_initArgs);
        }
        sideFilterAndContent.prependShowButton = prependShowButton;
        function saveFilterState() {
            if (appn.localStorage.getItem('sidefilter-toggle-collapsed'))
                appn.localStorage.setItem('sidefilter-toggle-collapsed', appn.emptyString);
            else
                appn.localStorage.setItem('sidefilter-toggle-collapsed', '1');
        }
        function hideSideFilter() {
            $('#elastic-right').hide();
            if (_initArgs.optionalContentToTheRight === true)
                $('#elastic-fill').removeClass('col-md-7').addClass('col-md-9');
            else
                $('#elastic-fill').removeClass('col-md-10').addClass('col-md-12');
            $('#showSideFilter').show();
            appn.dataTable.redrawOnResize(100);
            $('body').removeClass('sideFilter-shown').addClass('sideFilter-hidden');
            appn.pubSub.publish(appn.pubSub.WINDOW_RESIZED);
            if ($('body').hasClass('appn-view-tasks-calendar'))
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 300);
        }
        function showSideFilter() {
            if (_initArgs.optionalContentToTheRight === true)
                $('#elastic-fill').removeClass('col-md-9').addClass('col-md-7');
            else
                $('#elastic-fill').removeClass('col-md-12').addClass('col-md-10');
            $('#elastic-right').show();
            $('#showSideFilter').hide();
            appn.dataTable.redrawOnResize(100);
            $('body').removeClass('sideFilter-hidden').addClass('sideFilter-shown');
            appn.pubSub.publish(appn.pubSub.WINDOW_RESIZED);
            if ($('body').hasClass('appn-view-tasks-calendar'))
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 300);
        }
        function getShowBtn(classes) {
            const filterBtnClass = `class="btn btn-tool ${(classes ? classes : appn.emptyString)}"`;
            const filterBtnIcon = '<i class="fa fa-filter"></i>';
            const btnHtml = `<button id="showSideFilter" title="Show more Filters" style="display: none;" ${filterBtnClass} type="button">${filterBtnIcon}</a>`;
            return btnHtml;
        }
        function addEvents() {
            $('.hideSideFilter').off().on('click', function (event) {
                event.preventDefault();
                hideSideFilter();
                saveFilterState();
            });
            $('#showSideFilter').off().on('click', function (event) {
                event.preventDefault();
                showSideFilter();
                saveFilterState();
            });
        }
    })(sideFilterAndContent = appn.sideFilterAndContent || (appn.sideFilterAndContent = {}));
})(appn || (appn = {}));
